import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { Button, Row, Col, Container, Dropdown, Form, ListGroup } from 'react-bootstrap';

const DynamicScreen = () => {

  const mysqlToHtmlInputType = {
    INT: 'number',
    TINYINT: 'number',
    SMALLINT: 'number',
    MEDIUMINT: 'number',
    BIGINT: 'number',
    DECIMAL: 'number',
    FLOAT: 'number',
    DOUBLE: 'number',
    DATE: 'date',
    TIME: 'time',
    DATETIME: 'datetime-local',
    TIMESTAMP: 'datetime-local',
    YEAR: 'number',
    CHAR: 'text',
    VARCHAR: 'text',
    TINYTEXT: 'text',
    TEXT: 'text',
    MEDIUMTEXT: 'text',
    LONGTEXT: 'text',
    ENUM: 'select',
    SET: 'select',
    TINYBLOB: 'file',
    BLOB: 'file',
    MEDIUMBLOB: 'file',
    LONGBLOB: 'file',
    BOOLEAN: 'checkbox',
  };
  const [fieldss, setFieldss] = useState([{ schema_name: '', primary_table: '', primary_table_value: '', primary_table_text: '', relation_table: '', relation_table_value: '', relation_dependency_value: '', primary_dependency_value: '' }]);
  const [tableFields, setTableFields] = useState([]);
  const [schema, setSchema] = useState([]);
  const [selectedSchema, setSelectedSchema] = useState('');
  const [tables, setTables] = useState([]);
  const [selectedTable, setSelectedTable] = useState('');
  const [selectedPrimaryvalue, setSelectedPrimaryvalue] = useState('');
  const [fields, setFields] = useState([]);
  const [foreignKeyTable, setForeignKeyTable] = useState([]);
  const [relationShipTable, setRelationShipTable] = useState([]);



  const [relationfields, setRelatinFields] = useState([]);
  const [columns, setColumns] = useState([]);
  const [values, setValues] = useState([]);

  const [selectedPrimarytext, setSelectedPrimarytext] = useState('');
  const [shouldShowColumn, setShouldShowCOlumn] = useState(true);

  const getRelationshipDetails = async (schemaName) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getRelationshipDetailsTable/${schemaName}`);
      setRelationShipTable(response.data);
      console.log("relationShipDetails", response.data);
    } catch (error) {
      console.error('Error loading tables:', error);
    }
  }

  const getForeignKeyDetails = async (schemaName) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getForeignKeyDetails/${schemaName}`);
      setForeignKeyTable(response.data);
      console.log('foreign key tables', response.data);
    } catch (error) {
      console.error('Error loading schema:', error);
    }
  };

  const loadData = async () => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + 'api/getDatabases');
      setSchema(response.data);
    } catch (error) {
      console.error('Error loading schema:', error);
    }
  };

  const loadTables = async (schemaName) => {
    try {
      const response = await axios.get(process.env.REACT_APP_API_URL + `api/getTables/${schemaName}`);
      setTables(response.data);
    } catch (error) {
      console.error('Error loading tables:', error);
    }
  };

  const handleSchemaChange = (schemaName) => {
    setSelectedSchema(schemaName);
    getForeignKeyDetails(schemaName);
    getRelationshipDetails(schemaName);
    loadTables(schemaName);
    setSelectedTable(''); // Clear the selected table when changing the schema
    const newFields = [...fieldss];
    newFields['schema_name'] = schemaName;
    setFieldss([{ schema_name: '', primary_table: '', primary_table_value: '', primary_table_text: '', relation_table: '', relation_table_value: '', relation_dependency_value: '', primary_dependency_value: '' }]);
  };

  const loadFields = async (tableName) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + `api/getTableFields/${selectedSchema}/${tableName}`
      );
      setFields(response.data);
      console.log('fields data', response.data);
    } catch (error) {
      console.error('Error loading fields:', error);
    }
  };

  const handleRefresh = async () => {
    
    const notEqualItemsInsert = foreignKeyTable.filter((forItem) => {
      // Check if there is no matching relation in relationShipTable
      const hasMatchingRelation = relationShipTable.some((item) => forItem.TABLE_NAME === item.Relation_Table);

      // Return true for items without a match, false for items with a match
      return !hasMatchingRelation;
    });

      try {
        const response = await axios.post(process.env.REACT_APP_API_URL + `api/insertExtraRelationdata`, {
          SelectedSchema: selectedSchema,
         
        });


      } catch (error) {
        console.error(error);

      }
    



  }

  const handleTableChange = (tableName) => {
    setSelectedTable(tableName);
    setSelectedPrimaryvalue(''); // Clear the selected value when changing the table
    loadFields(tableName);
    const newFields = [...fieldss];
    newFields['primary_table'] = tableName;
    setFieldss(newFields);
  };

  const handleFieldChangeValue = (field) => {
    setSelectedPrimaryvalue(field);
    const newFields = [...fieldss];
    newFields['primary_table_value'] = field;
    setFieldss(newFields);
  };


  const handleFieldChangeText = (field) => {
    setSelectedPrimarytext(field);
    const newFields = [...fieldss];
    newFields['primary_table_text'] = field;
    setFieldss(newFields);

  };


  const handleChangeInput = async (index, event) => {
    const table_name = event.target.value;
    console.log("selected relation table:", table_name)
    const newFields = [...fieldss];
    newFields[index]['relation_table'] = table_name;
    newFields[index]['relation_table_value'] = '';
    newFields[index]['relation_dependency_value'] = '';
    newFields[index]['primary_dependency_value'] = '';
    setFieldss(newFields);
    // Fetch table fields dynamically based on the selected table
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + `api/getFields/${selectedSchema}/${table_name}`
      );
      const updatedTableFields = [...tableFields];
      updatedTableFields[index] = response.data;
      setTableFields(updatedTableFields);
    } catch (error) {
      console.error('Error loading fields:', error);
    }
  };

  const handleField1Change = (index, event) => {
    const { value } = event.target;
    const newFields = [...fieldss];
    newFields[index]['relation_table_value'] = value;
    setFieldss(newFields);
  };
  const handleField2Change = (index, event) => {
    const { value } = event.target;
    const newFields = [...fieldss];
    newFields[index]['relation_dependency_value'] = value;
    setFieldss(newFields);
  };

  const handleField3Change = (index, event) => {
    const { value } = event.target;
    const newFields = [...fieldss];
    newFields[index]['primary_dependency_value'] = value;
    setFieldss(newFields);
  }

  const handleAddFields = () => {
    setFieldss([...fieldss, { schema_name: '', primary_table: '', primary_table_value: '', primary_table_text: '', relation_table: '', relation_table_value: '', relation_dependency_value: '', primary_dependency_value: '' }]);
  };

  const handleRemoveFields = (index) => {
    const newFields = [...fieldss];
    newFields.splice(index, 1);
    setFieldss(newFields);
  };

  const handleSubmits = async (event) => {
    event.preventDefault();

    const updatedFieldss = fieldss.map(field => ({
      ...field,
      primary_table: selectedTable,
      primary_table_value: selectedPrimaryvalue,
      primary_table_text: selectedPrimarytext,
      schema_name: selectedSchema
    }));

    console.log(updatedFieldss); // You can perform further actions here, like sending data to an API

    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + `api/insertRelationdata`, {
        SelectedSchema: selectedSchema,
        relationship_table_data: updatedFieldss
      });

      toast.success('Data inserted successfully', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    } catch (error) {
      console.error(error);
      toast.error('Error inserting data', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }

  };

  useEffect(() => {
    loadData();
  }, []);



  return (
    <div>
      <ToastContainer />
      <div style={{ marginTop: '50px', marginLeft: '10px', marginRight: '10px' }}>
        <Row>
          <Col>
            <h2>Relationship Management</h2>
          </Col>
        </Row>
        <Row style={{ border: '5px solid #D5D5DD', backgroundColor: '#93b874', marginBottom: '0px', position: 'sticky', top: '0', zIndex: '1' }}>
          <Col xs={6} md={6}>
            <h2 style={{textAlign:'left'}}>Schemas</h2>
            <Form.Group>
              {/* <Form.Label>Select Schema</Form.Label> */}
              <Form.Control
                as="select"
                custom
                name='schema_name'
                value={selectedSchema}
                onChange={(e) => handleSchemaChange(e.target.value)}
                style={{ height: '40px', width: '100%', marginTop: '15px', marginBottom: 15 }}
              >
                <option value="">Select Schema</option>
                {schema.map((item, index) => (
                  <option key={index} value={item.Database}>
                    {item.Database}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
          {shouldShowColumn && (
            <Col xs={6} md={6} className="d-flex align-items-center justify-content-center">
              <Button onClick={() => handleRefresh()}>Auto Fetch <FontAwesomeIcon icon={faRotateRight} /></Button>
            </Col>

          )}
        </Row>
        {/* -----------------------primary table----------------------------------- */}
        {selectedSchema ? (
          <Row>
            <Col xs={12} md={6} style={{ backgroundColor: '#D0BFDC', padding: '10px' }}>
              <h2>Primary Table Details</h2>
              <Form>
                <Form.Group style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
                  <Form.Label style={{textAlign:'left', fontWeight: 'bold', marginRight: '10px', flex: '1' }}>Primary Table</Form.Label>
                  <Form.Control
                    as="select"
                    custom
                    name='primary_table'
                    onChange={(e) => handleTableChange(e.target.value)}
                    value={selectedTable}
                    style={{ height: '40px', flex: '2' }}
                  >
                    <option value="">Select table</option>
                    {tables.map((item, index) => (
                      <option key={index} value={item.Tables}>
                        {item.Tables}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>

                {selectedTable ? (
                  <Form.Group style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
                    <Form.Label style={{ textAlign:'left', fontWeight: 'bold', marginRight: '10px', flex: '1' }}>Primary Table Value</Form.Label>
                    <Form.Control
                      as="select"
                      custom
                      onChange={(e) => handleFieldChangeValue(e.target.value)}
                      //value={selectedPrimaryvalue}
                      style={{ height: '40px', flex: '2' }}
                    >
                      <option value="">Select value column</option>
                      {fields.map((item, index) => (
                        <option key={index} value={item.column_name}>
                          {item.column_name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                ) : null}

                {selectedTable ? (
                  <Form.Group style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
                    <Form.Label style={{ textAlign:'left', fontWeight: 'bold', marginRight: '10px', flex: '1' }}>Primary Table Text</Form.Label>
                    <Form.Control
                      as="select"
                      custom
                      onChange={(e) => handleFieldChangeText(e.target.value)}
                      value={selectedPrimarytext}
                      style={{ height: '40px', flex: '2' }}
                    >
                      <option value="">Select text column</option>
                      {fields.map((item, index) => (
                        <option key={index} value={item.column_name}>
                          {item.column_name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                ) : null}

              </Form>
            </Col>
            {/*--------------------------------------- Relation table -------------------------*/}
            {selectedTable ? (
              <Col xs={12} md={6} style={{ backgroundColor: '#E8E0EE', padding: '10px' }}>
                <h2>Relation Table Details</h2>
                <Form onSubmit={handleSubmits}>
                  {fieldss.map((field, index) => (
                    <div key={index}>

                      <Form.Group style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
                        <Form.Label style={{ textAlign:'left', fontWeight: 'bold', marginRight: '10px', flex: '1' }}>Relation Table</Form.Label>
                        <Form.Control
                          as="select"
                          custom
                          name='relation_table'
                          onChange={(event) => handleChangeInput(index, event)}
                          value={fieldss[index].relation_table}
                          style={{ height: '40px', flex: '2' }}
                        >
                          <option value="">Select relation table</option>
                          {tables.map((item, index) => (
                            <option key={index} value={item.Tables}>
                              {item.Tables}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>


                      <Form.Group style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
                        <Form.Label style={{textAlign:'left', fontWeight: 'bold', marginRight: '10px', flex: '1' }}>Relation Value</Form.Label>
                        <Form.Control
                          as="select"
                          custom
                          name='relation_table_value'
                          onChange={(event) => handleField1Change(index, event)}
                          value={fieldss[index].relation_table_value}
                          style={{ height: '40px', flex: '2' }}
                        >
                          <option value="">Select value column</option>
                          {tableFields[index]?.map((item, index) => (
                            <option key={index} value={item.column_name}>
                              {item.column_name}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>


                      <Form.Group style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
                        <Form.Label style={{textAlign:'left', fontWeight: 'bold', marginRight: '10px', flex: '1' }}>Relation Dependency Value</Form.Label>
                        <Form.Control
                          as="select"
                          custom
                          name='relation_dependency_value'
                          onChange={(event) => handleField2Change(index, event)}
                          value={fieldss[index].relation_dependency_value}
                          style={{ height: '40px', flex: '2' }}
                        >
                          <option value="">Select value column</option>
                          {tableFields[index]?.map((item, index) => (
                            <option key={index} value={item.column_name}>
                              {item.column_name}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>


                      <Form.Group style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
                        <Form.Label style={{textAlign:'left', fontWeight: 'bold', marginRight: '10px', flex: '1' }}>Primary Dependency Value</Form.Label>
                        <Form.Control
                          as="select"
                          custom
                          name='primary_dependency_value'
                          onChange={(event) => handleField3Change(index, event)}
                          value={fieldss[index].primary_dependency_value}
                          style={{ height: '40px', flex: '2' }}
                        >
                          <option value="">Select value column</option>
                          {fields.map((item, index) => (
                            <option key={index} value={item.column_name}>
                              {item.column_name}
                            </option>
                          ))}
                        </Form.Control>
                      </Form.Group>


                      <Button type="button" variant='danger' onClick={() => handleRemoveFields(index)}>
                        Remove
                      </Button>


                    </div>
                  ))}
                  <Button type="button" style={{ float: 'right' }} variant='success' onClick={handleAddFields}>
                    Add More
                  </Button>


                  <Button
                    type="submit"
                    variant="primary"
                    style={{ width: '100%', height: '40px' }}
                    className="custom-button"
                  >
                    Submit
                  </Button>
                </Form>
              </Col>
            ) : null}
          </Row>
        ) : null}

      </div>

    </div>

  );
};

export default DynamicScreen;
